import { FunctionComponent } from 'react'
import { Box, Divider, SwipeableDrawer, Typography } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { NotificationDetails } from './NotificationDetails'
import { Notification } from 'common/types/notification.types'
import styled from 'styled-components/macro'
import { ClearAll } from '@material-ui/icons'
import { BackendUser } from 'common/types'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Loader } from 'components/core/loader'
import { useViewNotifications } from './hooks/useViewNotification'
import { Button } from 'common/atoms/Button/Button'

const StyledDivider = styled(Divider)`
  && {
    background-color: ${props => props.theme.colors.supplementary1};
  }
`

interface NotificationDrawerProps {
  user?: BackendUser
  drawer: boolean
  setDrawer: Function
  theme: any
  notifications: Notification[]
  totalNotifications: number
  updateNotification: Function
  isDevice: boolean
  isTablet: boolean
  setNotifications: Function
  setTotalNotifications: Function
  tabIndex: number
  setTabIndex: Function
  backendUser: any
  clearNotifications: Function
  setNotificationPage: Function
  notificationPage?: number
  handleStoringLatestNotification: Function
}

const NotificationsContainer = styled(Box)`
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  height: 90vh;
  overflow-y: scroll;
  @media (min-height: ${props => props.theme.breakpoints.large}) {
    height: 85%;
  }
`
const StyledClose = styled(Close)`
  && {
    display: flex;
    float: right;
    color: ${props => props.theme.colors.accent1};
  }
`

const StyledSwipeableDrawer = styled(SwipeableDrawer)`
  && {
    overflow-y: hidden;

    .MuiDrawer-paper {
      border-radius: 15px;
      overflow-y: scroll;
      ::-webkit-scrollbar {
        display: none;
      }
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }
    .MuiButton-root {
      font-weight: bold;
    }
  }
  &.MuiDrawer-paper {
    overflow-y: hidden;
  }
`

export const NotificationDrawer: FunctionComponent<NotificationDrawerProps> = ({
  drawer,
  setDrawer,
  theme,
  notifications,
  totalNotifications,
  updateNotification,
  isDevice,
  isTablet,
  setNotifications,
  setTotalNotifications,
  setTabIndex,
  tabIndex,
  clearNotifications,
  user,
  setNotificationPage,
  notificationPage,
  handleStoringLatestNotification
}) => {

  const fetchMore = (type: string) => {
    switch (type) {
      case 'notifications':
        setNotificationPage(notificationPage + 1)
        break
    }
  }

  const { viewNotification, getDataFromMessage } = useViewNotifications()

  return (
    <StyledSwipeableDrawer
      open={drawer}
      onOpen={() => setDrawer(true)}
      onClose={() => {
        setDrawer(false)
        setNotificationPage(1)
        handleStoringLatestNotification()
      }}
      anchor="right"
    >
      <Box
        width={isDevice && !isTablet ? '25em' : '30em'}
        bgcolor={theme.colors.supplementary}
        position={'relative'}
      >
        <Box position={'absolute'} right={48} top={20} zIndex={1000}>
          <StyledClose
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setDrawer(false)
              setNotificationPage(1)
              handleStoringLatestNotification()
            }}
          />
        </Box>
        <Box color={theme.colors.accent1} display="flex" justifyContent="center" m="1rem 0">
          <Typography variant='subtitle1'>
            Pings
          </Typography>
        </Box>
        <StyledDivider />
        <Box>
          {tabIndex === 0 && (
            <Box
              width={isDevice && !isTablet ? '25em' : '30em'}
              bgcolor={theme.colors.supplementary}
              height="100%"
              overflow="auto"
            >
              <Box display="flex" justifyContent="space-between" padding={'0 3em 0'}>
                <Box display="flex" alignItems="center" color={theme.colors.accent1}>
                  <Typography variant='body1'>
                    <Box fontWeight="700">
                      {totalNotifications
                        ? `You have ${totalNotifications} new ${Number(totalNotifications) === 1 ? 'ping' : 'pings'}`
                        : `You have no new pings`}
                    </Box>
                  </Typography>
                </Box>
                <Box
                  mr="0.5em"
                >
                  <Button
                    design='tertiary'
                    leftIcon={<ClearAll color={theme.colors.accent1} style={{ marginRight: '-0.2rem' }}/>}
                    onClick={() => {
                      clearNotifications(user?.id)
                      setNotifications([])
                      setTotalNotifications(0)
                    }}
                  >
                    Clear All
                  </Button>
                </Box>
              </Box>
              {notifications && (
                <NotificationsContainer id="scrollablePings">
                  <InfiniteScroll
                    loader={<Loader />}
                    hasMore={totalNotifications > notifications?.length}
                    endMessage={
                      <p style={{ textAlign: 'center', color: theme.colors.accent1 }}>
                        {notifications?.length === 0 ? null : <b>No More Pings</b>}
                      </p>
                    }
                    next={() => {
                      fetchMore('notifications')
                    }}
                    dataLength={notifications?.length}
                    scrollableTarget="scrollablePings"
                  >
                    {notifications?.map(notification => {
                      return (
                        <>
                          <StyledDivider style={{ margin: "0 0 1em 0" }}/>
                          <Box padding={'0em 3em'}>
                            <NotificationDetails
                              getDataFromMessage={getDataFromMessage}
                              viewNotification={viewNotification}
                              totalNotifications={totalNotifications}
                              key={notification.id}
                              notifications={notifications}
                              setNotifications={setNotifications}
                              setTotalNotifications={setTotalNotifications}
                              notification={notification}
                              action={notification?.action === 'summit_reminder' ? 'Get Pass' : 'View'}
                              theme={theme}
                              setDrawer={setDrawer}
                              updateNotification={updateNotification}
                            />
                          </Box>
                        </>
                      )
                    })}
                  </InfiniteScroll>
                </NotificationsContainer>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </StyledSwipeableDrawer>
  )
}
